import './metrics_view.js.coffee'
Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.FacebookMetricsView extends Monitoring.Reports.DailyInsights.MetricsView
  template: JST['backbone/templates/monitoring/reports/daily_insights/facebook_metrics']
  
  initialize: (@options = {}) =>
  	@$el.addClass('fb-metrics')
  	super(@options)
